var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M31.5101 15.0182C31.5101 17.3833 30.4458 19.5119 28.9085 21.0492C28.199 20.1031 27.0164 19.5119 25.5974 19.5119C26.3069 15.7277 22.4045 12.7713 19.0933 14.5451C18.5021 12.8896 17.3195 11.4705 15.7822 10.761C17.2013 8.27764 19.9211 6.62207 23.114 6.62207C27.7259 6.62207 31.5101 10.288 31.5101 15.0182Z",
    fill: "url(#paint0_linear_312_3445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M23.1159 4.7302C22.5247 4.7302 22.1699 4.25718 22.1699 3.78416V0.946038C22.1699 0.473019 22.5247 0 23.1159 0C23.589 0 24.062 0.473019 24.062 0.946038V3.78416C24.062 4.25718 23.589 4.7302 23.1159 4.7302Z",
    fill: "url(#paint1_linear_312_3445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M37.0684 15.9644H34.2302C33.7572 15.9644 33.2842 15.4913 33.2842 15.0183C33.2842 14.427 33.7572 14.0723 34.2302 14.0723H37.0684C37.5414 14.0723 38.0144 14.427 38.0144 15.0183C38.0144 15.4913 37.5414 15.9644 37.0684 15.9644Z",
    fill: "url(#paint2_linear_312_3445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M31.0352 8.04135C30.2075 8.04135 29.7344 6.97706 30.3257 6.38578L32.3361 4.37545C32.6908 4.02068 33.2821 4.02068 33.6369 4.37545C33.9916 4.73021 33.9916 5.32149 33.6369 5.79451L31.6265 7.68658C31.4688 7.92309 31.2718 8.04135 31.0352 8.04135Z",
    fill: "url(#paint3_linear_312_3445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_5",
    d: "M32.9292 25.7795C32.6927 25.7795 32.4956 25.7007 32.3379 25.543L30.3276 23.5327C29.9728 23.1779 29.9728 22.5867 30.3276 22.2319C30.6824 21.8771 31.2736 21.8771 31.6284 22.2319L33.6388 24.2422C34.23 24.8335 33.757 25.7795 32.9292 25.7795Z",
    fill: "url(#paint4_linear_312_3445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_6",
    d: "M15.1901 8.04135C14.9535 8.04135 14.717 7.92309 14.4805 7.68658L12.4702 5.79451C12.1154 5.32149 12.1154 4.73021 12.4702 4.37545C12.9432 4.02068 13.5345 4.02068 13.8892 4.37545L15.7813 6.38578C16.3726 6.97706 16.0178 8.04135 15.1901 8.04135Z",
    fill: "url(#paint5_linear_312_3445)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_7",
    d: "M24.178 21.2864C24.8875 17.5022 20.9851 14.5459 17.5557 16.2014C16.8462 13.8363 14.5993 12.0625 11.8794 12.0625C8.45004 12.0625 5.73017 15.0189 5.96668 18.5665C3.12857 18.6848 1 21.0499 1 24.0062C1 26.9626 3.36511 29.446 6.43973 29.446H24.178C26.4248 29.446 28.3169 27.5539 28.3169 25.307C28.3169 23.1785 26.6613 21.2864 24.178 21.2864Z",
    fill: "url(#paint6_linear_312_3445)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>_8",
    d: "M5.96677 31.5735C5.61201 31.337 5.02074 31.5735 4.90248 32.0465L3.48341 35.7124C3.2469 36.1854 3.4834 36.6585 3.95642 36.7767C4.31119 37.0132 4.90245 36.7767 5.02071 36.3037L6.43978 32.6378C6.67629 32.1648 6.43979 31.6917 5.96677 31.5735Z",
    fill: "url(#paint7_linear_312_3445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_9",
    d: "M18.6179 30.9824C18.1449 30.7459 17.6718 30.9824 17.4353 31.4555L16.0163 35.1214C15.898 35.5944 16.0163 36.0674 16.4893 36.1857C16.9623 36.4222 17.4353 36.1856 17.5536 35.7126L19.0909 32.0467C19.2092 31.5737 18.9726 31.1007 18.6179 30.9824Z",
    fill: "url(#paint8_linear_312_3445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_10",
    d: "M11.9961 34.6489C11.6413 34.5307 11.1683 34.7672 10.9317 35.1219L9.51271 38.7878C9.2762 39.2609 9.5127 39.7339 9.98572 39.9704C10.4587 40.0887 10.9318 39.8521 11.05 39.4974L12.4691 35.7132C12.7056 35.3584 12.4691 34.8854 11.9961 34.6489Z",
    fill: "url(#paint9_linear_312_3445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_11",
    d: "M23.3493 34.1766C22.8763 34.0584 22.4033 34.2949 22.1668 34.7679L20.7477 38.4338C20.6295 38.7885 20.7477 39.3798 21.2207 39.4981C21.6938 39.6163 22.1668 39.4981 22.285 39.0251L23.8224 35.3592C23.9406 34.8861 23.7041 34.4131 23.3493 34.1766Z",
    fill: "url(#paint10_linear_312_3445)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_3445",
    x1: 15.5635,
    y1: -6.11753,
    x2: 38.952,
    y2: 14.0672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_3445",
    x1: 20.4623,
    y1: -7.22419,
    x2: 42.7165,
    y2: 11.9819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_3445",
    x1: 14.0867,
    y1: -4.90299,
    x2: 36.0575,
    y2: 14.0578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_312_3445",
    x1: 2.06028,
    y1: -23.3198,
    x2: 50.3051,
    y2: 18.3163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_312_3445",
    x1: 9.39637,
    y1: 0.807655,
    x2: 30.8593,
    y2: 19.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_312_3445",
    x1: 13.7331,
    y1: 2.11205,
    x2: 35.1929,
    y2: 20.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_312_3445",
    x1: 0.942055,
    y1: 12.0483,
    x2: 28.3181,
    y2: 12.0483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_312_3445",
    x1: -20.0564,
    y1: 5.79981,
    x2: 13.9385,
    y2: 35.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_312_3445",
    x1: -20.9952,
    y1: -6.49614,
    x2: 12.9936,
    y2: 22.9613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_312_3445",
    x1: -23.8104,
    y1: 0.434237,
    x2: 10.1734,
    y2: 29.8872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_312_3445",
    x1: -24.7403,
    y1: -10.5604,
    x2: 9.24615,
    y2: 18.8946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67A4FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainSun);
export default __webpack_public_path__ + "static/media/rainSun.f4641ce48f507aaf78571659b9aba004.svg";
export { ForwardRef as ReactComponent };